import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { CreateProcedureHubPage } from './CreateProcedureHubPage';

const CreateProcedureHubPageBridge = react2angular(CreateProcedureHubPage, []);
export { CreateProcedureHubPageBridge };
